import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "@/assets/fade-in.css";
import "@/assets/element-variables.scss";
import "@/assets/normalize.scss";
import "@/assets/iconfont.css";
import "@/assets/commonflex.scss";
import systemInit from "@/utils/system";
import Toast from "@/components/common/toast";
import { LibMsgBox } from "qlmbidding2_pc_lib";
import trackDirective from "@/utils/tracker.js";
import "qlmbidding2_pc_lib/static/theme.scss";
import { CDN } from "@/utils/constants/constants";

Vue.config.productionTip = false;
console.log("process.env:", process.env);
Vue.use(ElementUI);
Vue.use(Toast);
Vue.prototype.$libMsgBox = LibMsgBox;
Vue.use(trackDirective);
/** 官网OSS origin **/
Vue.prototype.$cdn = CDN;

async function appInit() {
  try {
    systemInit.basicFunctionInit();
    systemInit.basicListenersInit();
    systemInit.urlAddressDataProcessing();
  } catch (e) {
    console.error("System Init Error");
  }
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
}

appInit();
